export default {
    "getProductRewardPoints": "a2f978d37f982e1fcedaaffa196e9358fd607a066307f8387b21223d85ff93bf",
    "customer": "797760ed65b5642b5caa777ffcf6e81d4d8b7dd70419b2f35b80f3c1ac8461a6",
    "setVipStatusOpt": "78adcb62f96c45ea0aab71377b2732e2f16d4bf42eba23e5002de42ac5f848ca"
};
